import { ETopic } from '@cian/feedback-form-widget';

import { TReduxActions } from '../../actions';
import { ETopicActionTypes } from '../../actions/topic';
import { TTopicType } from '../../types/topicState';

const defaultState: ETopic | null = null;

export function topicReducer(state: TTopicType = defaultState, action: TReduxActions): TTopicType {
  switch (action.type) {
    case ETopicActionTypes.SetTopic:
      return action.payload.topic;
    default:
      return state;
  }
}
